import React from "react";
import { useQuery } from "@apollo/client";
import { GET_NOTIFICATION } from "../../GraphQL/Queries";
import { Wrapper } from "../base/Wrapper.jsx";
import TitleBar from "../TitleBar.jsx";
import ErrorPage from "../ErrorPage/ErrorPage";
import { Typography } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";

function Notification() {
  const { data, isLoading, error } = useQuery(GET_NOTIFICATION);
  const notification = data?.mitteilungCollection?.items[0]?.content;
  const iframeUrl = notification?.iframe?.split('"')[1];

  if (isLoading || !data || !notification) return null;
  if (error) return <ErrorPage />;

  return (
    <div>
      <TitleBar
        title={notification.__typename === "Umfrage" ? "Umfrage" : "Mitteilung"}
        navigateTo="/feed"
        colorPrimary
      />
      <Wrapper>
        <Typography component="h2" variant="h5" gutterBottom style={{ textAlign: "center" }}>
          {notification.title}
        </Typography>
        <Typography variant="subtitle2">{notification.description}</Typography>
        {iframeUrl && (
          <iframe
            src={iframeUrl}
            width="100%"
            height="500"
            frameBorder="0"
            marginHeight="0"
            marginWidth="0"
            title="Umfrage"
          >
            <CircularProgress />
          </iframe>
        )}
      </Wrapper>
    </div>
  );
}

export default Notification;
